<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card px-0">
                    <h4 class="card-title">Exemplary Performances</h4>
                    <div class="card-body text-justify">
                        <p class="lead text-justify inner-lead">MPPS is recognized  for its outstanding  Board results &  achieving Top Positions  in the District . Our students  excel not only in the Board exams but also  in the competitive exams & thus securing  admissions in the Premier  Institutes .
                            We are proud to say that in every  season of examinations our students keep on adding more branches of achievements to the  success tree of MPPS .</p>
                        <h5>Session 2024-25</h5>
                        <hr class="pb-1 opacity-100 rounded">
                        <!-- <div class="container-fluid d-flex justify-content-center align-items-center h-100" id="loader" *ngIf="isLoading">
                            <app-loader></app-loader>
                        </div>
                        <div id="detail" class="text-center">
                            <pdf-viewer [src]="pdfSrc" 
                            [render-text]="true"
                            style="display: block;"
                            id="list-view"
                            
                            (on-progress)="hideLoader()" (error)="hideLoader()"></pdf-viewer>
                </div> -->
                <div class="row">
                    <div class="col-12 col-sm-6 text-center mb-4" *ngFor="let img of imgUrl;let i = index">
                      <a href="{{img}}" data-lightbox="Performances"><img [src]="img" alt="Performances" class="img-fluid rounded"></a>
                      </div>
                  </div>
                    
                </div>
                <iframe src="https://drive.google.com/file/d/16KT8DLz13LOFDy73hwlPjexqNBMinsot/preview" width="100%" height="1100" allow="autoplay" class="mt-4"></iframe>
                <h5>Previous Session </h5>
                <hr class="pb-1 opacity-100 rounded">
                <iframe src="https://drive.google.com/file/d/1mGHB-1mom7s9d7uyGlu1WMlGzXWWcqAF/preview" width="100%" height="1100" allow="autoplay" class="mt-4"></iframe>
        </div>

       
    </div>
</div>